/**
 * Autogenerated file don't modify
 */
(function () {
(function (swiper) {
    'use strict';

    MoyaComponents.register('site.carousel', [
        'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css',
        'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js',
    ], function (el) {
        var selector = '#' + el.id + ' .swiper-container';
        var params = null;
        if (selector.includes('newsheadlines')) {
            params = Carousel.handleNewsHeadlines();
        }
        else if (selector.includes('eventlist')) {
            params = Carousel.handleEventlist();
        }
        else {
            console.log(selector);
        }
        if (!params) {
            return;
        }
        var swiper$1 = new swiper.Swiper(selector, params);
        swiper$1.on('transitionEnd', function () {
            swiper$1.slides.forEach(function (slide) {
                slide.classList.remove('slide-preview');
            });
            var nextElm = document.querySelector('.swiper-slide-visible + :not(.swiper-slide-visible)');
            if (nextElm) {
                nextElm.classList.add('slide-preview');
            }
        });
    });
    var Carousel = /** @class */ (function () {
        function Carousel() {
        }
        Carousel.handleNewsHeadlines = function () {
            return {
                direction: 'horizontal',
                slidesPerView: 1.2,
                spaceBetween: 30,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: '.button-next',
                    prevEl: '.button-prev',
                },
                breakpoints: {
                    560: {
                        slidesPerView: 1.2,
                    },
                    860: {
                        slidesPerView: 2.2,
                    },
                    1100: {
                        slidesPerView: 3,
                    },
                },
            };
        };
        Carousel.handleEventlist = function () {
            return {
                direction: 'horizontal',
                slidesPerView: 1,
                spaceBetween: 15,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: '.button-next',
                    prevEl: '.button-prev',
                },
                breakpoints: {
                    560: {
                        slidesPerView: 1,
                    },
                    860: {
                        slidesPerView: 2,
                    },
                    1100: {
                        slidesPerView: 4,
                    },
                },
            };
        };
        return Carousel;
    }());

}(window));
typeof tsBuild === 'function' && tsBuild();})();
